import { InsuranceClaimPageType_insuranceClaimPage_personalizedClaimLinksCollection_items } from "@containers/InsuranceClaimPage/queries/contentfulTypes/InsuranceClaimPageType";
import { IVImage } from "@utils/imageHelpers/imageHelper";

import { Context } from "types/context/Context";

import InformationArea from "../InformationArea/InformationArea";
import InformationAreaLink from "../InformationAreaLink";

export interface IInsuranceAbout {
  heading: string;
  image: IVImage;
  bulletListItems: string[];
  informationMessage: any;
  links: InsuranceClaimPageType_insuranceClaimPage_personalizedClaimLinksCollection_items[];
  context: Context;
  contentfulPreviewEntryId?: string;
  contentfulPreviewHeadingFieldId?: string;
  contentfulPreviewUspsFieldId?: "uspar";
}

const InsuranceAbout = ({
  heading,
  image,
  bulletListItems,
  informationMessage,
  links,
  context,
  contentfulPreviewEntryId,
  contentfulPreviewHeadingFieldId,
  contentfulPreviewUspsFieldId,
}: IInsuranceAbout) => {
  return (
    <InformationArea
      heading={heading}
      image={image}
      type={"about"}
      bulletListType="check"
      informationMessageType="info"
      bulletListItems={bulletListItems}
      informationMessage={informationMessage}
      contentfulPreviewEntryId={contentfulPreviewEntryId}
      contentfulPreviewHeadingFieldId={contentfulPreviewHeadingFieldId}
      contentfulPreviewUspsFieldId={contentfulPreviewUspsFieldId}
      buttonChildren={
        <>
          {links?.map(
            (
              link: InsuranceClaimPageType_insuranceClaimPage_personalizedClaimLinksCollection_items,
              index: number,
            ) => (
              <InformationAreaLink
                key={index}
                link={link}
                insurance={context?.insuranceName || ""}
                index={index}
                state={"about"}
                contentfulPreviewEntryId={contentfulPreviewEntryId}
                contentfulPreviewLinkHeadingFieldId={"insuranceClaimButtonText"}
              />
            ),
          )}
        </>
      }
    />
  );
};

export default InsuranceAbout;
